/**
 * After refresh, the browser can restore scroll position after IntersectionObserver and
 * initial layout ran, so elements already in view never get callbacks. Reveal scripts
 * register a sync fn; we run all of them on load/pageshow with rAF + delayed passes.
 */
(function () {
  var rechecks = [];

  function runAll() {
    for (var i = 0; i < rechecks.length; i++) {
      try {
        rechecks[i]();
      } catch (e) {}
    }
  }

  function schedule() {
    function runDeferred() {
      runAll();
      setTimeout(runAll, 120);
    }
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        runDeferred();
      });
    } else {
      setTimeout(runDeferred, 0);
    }
  }

  window.r3nuRegisterViewportRecheck = function (fn) {
    if (typeof fn !== 'function') return;
    rechecks.push(fn);
  };

  window.addEventListener('load', schedule, { passive: true });
  window.addEventListener('pageshow', schedule, { passive: true });
})();
